
import DepartmentList from './index.vue'

DepartmentList.install = function (Vue) {
  Vue.component(DepartmentList.name, DepartmentList)
}

export default DepartmentList